/* LMGF search (replaces the search block in lmgf-market.js, which is switched off with window.__lmgfSearch).
   - Instant dropdown: Brands first (brand pages, not collections), then Categories, then Products.
   - Enter: if the text clearly names one brand ("ethels", "date smarter"), go straight to that brand page.
     Otherwise open /search, which shows matching brands on top and products below.
   Brand matching lives in snippets/lmgf-brand-match.liquid, served by sections/lmgf-brand-suggest.liquid.
   Inputs have no name="q" so third-party search popups leave them alone. */
(function () {
  window.__lmgfSearch = true;
  if (window.__lmgfSearch2) return;
  window.__lmgfSearch2 = true;

  var money = function (v) { var n = Number(v); if (isNaN(n)) return v; if (String(v).indexOf('.') === -1 && n > 999) n = n / 100; return '$' + n.toFixed(2); };
  var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var norm = function (s) { return String(s || '').toLowerCase().replace(/['’.!,®™]/g, '').replace(/-/g, ' ').replace(/&/g, 'and').replace(/\s+/g, ' ').trim(); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};
  (function () { if (document.getElementById('lmgf-sugg-css')) return; var st = document.createElement('style'); st.id = 'lmgf-sugg-css'; st.textContent = '.lm-sugg-b{display:flex;align-items:center;gap:12px;padding:8px 10px;border-radius:16px;text-decoration:none;color:#451311}.lm-sugg-b:hover,.lm-sugg-b:focus{background:#f8f1d4;outline:0}.lm-sugg-b:focus-visible{box-shadow:0 0 0 3px #451311}.lm-sugg-b .lg{flex:none;width:44px;height:44px;border-radius:12px;border:2px solid #451311;background:#fff;display:grid;place-items:center;overflow:hidden;box-shadow:2px 2px 0 0 #451311}.lm-sugg-b .lg img{max-width:84%;max-height:84%;object-fit:contain}.lm-sugg-b .lg.ph{font-family:"Recoleta Alt",Recoleta,Georgia,serif;font-weight:700;font-size:20px}.lm-sugg-b .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.lm-sugg-b b{font-family:"Recoleta Alt",Recoleta,Georgia,serif;font-weight:700;font-size:17px;line-height:1.15}.lm-sugg-b small{font-size:12px;font-weight:600;opacity:.75;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.lm-sugg-b .go{flex:none;display:inline-flex;align-items:center;gap:4px;height:30px;padding:0 10px;border-radius:30px;background:#ff9fad;font-weight:800;font-size:12px;color:#451311}.lm-sugg-b .go svg{width:13px;height:13px;fill:none;stroke:currentColor;stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}@media (max-width:480px){.lm-sugg-b .go{font-size:0;gap:0;padding:0 9px}}'; document.head.appendChild(st); })();

  function brands(q) {
    var k = norm(q);
    if (k.length < 3) return Promise.resolve([]);
    if (cache[k]) return cache[k];
    cache[k] = fetch(root + 'search?q=' + encodeURIComponent(q) + '&section_id=lmgf-brand-suggest')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/<script type="application\/json" data-lmgf-brands>([\s\S]*?)<\/script>/);
        try { return m ? JSON.parse(m[1]) : []; } catch (e) { return []; }
      }).catch(function () { return []; });
    return cache[k];
  }
  function strongOne(list) {
    var s = list.filter(function (b) { return b.strong; });
    return s.length === 1 ? s[0] : null;
  }
  function goSearch(q) { location.href = root + 'search?type=product&q=' + encodeURIComponent(q); }

  function init() {
    document.querySelectorAll('form[data-lm-search]').forEach(function (form) {
      var input = form.querySelector('[data-lm-q]');
      if (!input || form.__lms) return;
      form.__lms = 1;
      if (!form.style.position) form.style.position = 'relative';
      var box = document.createElement('div');
      box.className = 'lm-sugg'; box.hidden = true; box.setAttribute('role', 'listbox');
      box.id = (input.id || 'lmq') + '-sugg';
      input.setAttribute('aria-controls', box.id); input.setAttribute('aria-autocomplete', 'list');
      form.appendChild(box);
      var t, last = '', ctrl, busy = false;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = input.value.trim();
        if (!q || busy) return;
        busy = true;
        brands(q).then(function (list) {
          var b = strongOne(list);
          if (b) location.href = b.url; else goSearch(q);
        });
      });
      function close() { box.hidden = true; }

      input.addEventListener('input', function () {
        clearTimeout(t);
        var q = input.value.trim();
        if (q.length < 2) { close(); return; }
        t = setTimeout(function () {
          if (q === last && !box.hidden) return;
          last = q;
          if (ctrl) ctrl.abort();
          ctrl = window.AbortController ? new AbortController() : null;
          var pr = fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
            .then(function (r) { return r.json(); });
          Promise.all([brands(q), pr]).then(function (all) {
            if (input.value.trim() !== q) return;
            var bs = all[0] || [];
            var res = (all[1] && all[1].resources && all[1].resources.results) || {};
            var ps = res.products || [];
            /* hide collections that are just a brand's vendor collection, so the brand page wins */
            var keys = bs.map(function (b) { return norm(b.name).split(' ')[0]; }).filter(function (w) { return w.length > 3; });
            var cs = (res.collections || []).filter(function (c) {
              var n = norm(c.title);
              return !keys.some(function (k) { return n.indexOf(k) > -1; });
            }).slice(0, 3);
            var h = '';
            if (bs.length) h += '<div class="lm-sugg-h">Brands</div>' + bs.map(function (b) {
              return '<a class="lm-sugg-b" role="option" href="' + esc(b.url) + '">' +
                (b.logo ? '<span class="lg"><img src="' + esc(b.logo) + '" alt="" loading="lazy"></span>' : '<span class="lg ph">' + esc(b.name.charAt(0)) + '</span>') +
                '<span class="tx"><b>' + esc(b.name) + '</b>' + (b.tag ? '<small>' + esc(b.tag) + '</small>' : '') + '</span>' +
                '<span class="go">Brand page<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span></a>';
            }).join('');
            if (cs.length) h += '<div class="lm-sugg-h">Categories</div>' + cs.map(function (c) { return '<a class="lm-sugg-c" role="option" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('');
            if (ps.length) h += '<div class="lm-sugg-h">Products</div>' + ps.map(function (p) {
              return '<a class="lm-sugg-p" role="option" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<span class="ph"></span>') +
                '<span class="tx"><small>' + esc(p.vendor) + '</small><b>' + esc(p.title) + '</b></span><span class="pr">' + money(p.price) + '</span></a>';
            }).join('');
            h += (bs.length || ps.length || cs.length)
              ? '<a class="lm-sugg-all" href="' + root + 'search?type=product&q=' + encodeURIComponent(q) + '">See all results for "' + esc(q) + '"</a>'
              : '<p class="lm-sugg-none">No matches for "' + esc(q) + '". Try a brand or a food.</p>';
            box.innerHTML = h; box.hidden = false;
          }).catch(function () {});
        }, 180);
      });
      input.addEventListener('keydown', function (e) {
        var items = [].slice.call(box.querySelectorAll('a'));
        if (e.key === 'ArrowDown' && items.length && !box.hidden) { e.preventDefault(); items[0].focus(); }
        if (e.key === 'Escape') close();
      });
      box.addEventListener('keydown', function (e) {
        var items = [].slice.call(box.querySelectorAll('a')), i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[i]).focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) input.focus(); else items[i - 1].focus(); }
        if (e.key === 'Escape') { close(); input.focus(); }
      });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
      input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length > 1) box.hidden = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
